import { useState } from 'react';
import { useModalStore } from '../../stores/modalStore.js';
import { useSocketEmit } from '../../hooks/useSocket.js';
import { useAeThex } from '../../components/AeThexProvider';
import { Phone, PhoneOff } from 'lucide-react';

export default function VoiceCallButton() {
  const [isInCall, setIsInCall] = useState(false);
  const { onOpen } = useModalStore();
  const { startCall, endCall } = useSocketEmit();
  const { user } = useAeThex();

  const participantName = user?.display_name || user?.username || 'User';

  const handleStartCall = async () => {
    const roomName = `call-${Date.now()}`;
    setIsInCall(true);

    try {
      const response = await fetch('/api/livekit/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          roomName,
          participantName,
          role: 'participant',
        }),
      });

      const data = await response.json();
      if (data.success) {
        startCall(roomName, 'user-1', participantName);
        onOpen('voiceCall', { roomName, token: data.token, liveKitUrl: data.url });
      }
    } catch (error) {
      console.error('Failed to start call:', error);
      setIsInCall(false);
    }
  };

  const handleEndCall = () => {
    setIsInCall(false);
    endCall(`call-${Date.now()}`);
  };

  return (
    <button
      onClick={isInCall ? handleEndCall : handleStartCall}
      style={{
        width: 'var(--sz-btn)', height: 'var(--sz-btn)',
        borderRadius: 6, border: 'none', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: isInCall ? '#dc2626' : '#16a34a',
        color: '#fff', transition: 'background 0.2s', flexShrink: 0,
      }}
      title={isInCall ? 'End call' : 'Start voice call'}
    >
      {isInCall ? <PhoneOff size={14} /> : <Phone size={14} />}
    </button>
  );
}
